<script>
export default {
    name: 'IlluProximite',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-proximite"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M32 9.5c-4.004 0-7.63 1.623-10.253 4.247A14.455 14.455 0 0017.5 24c0 5.4 4.865 15.426 14.5 30.09C41.633 39.428 46.5 29.4 46.5 24c0-4.004-1.623-7.63-4.247-10.253A14.455 14.455 0 0032 9.5z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <circle
                :fill="primaryColor"
                class="primary-color"
                cx="32"
                cy="24"
                r="6"
            />
        </g>
    </svg>
</template>
